import { normalizeHost } from 'common/functions.js'
import { getTelegramLink } from 'src/configs/telegram.js'

export default {
  multiTableEnabled: true,
  code: 'r7cb4846',
  theme: 'red',
  showReminderModal: false,
  showRecoveryWithdrawLockWarning: false,
  showEventSlider: true,
  sportsBookLink: null,
  useDWH: false,
  useMirrors: false,
  baseLink: 'https://olimp.com',
  api: {
    transactions: 'g/transactions/',
  },
  app: {
    title: 'appOlymp',
    useToken: false,
    deepLinks: {
      default: 'default',
      platforms: [],
    },
  },
  appToken: false,
  headerSize: {
    desktop: 94,
    mobile: 44,
  },
  webviewHeaderSize: {
    desktop: 45,
    mobile: 45,
  },
  auth: {
    defaultTab: 'login',
    socialStyle: { order: 1 },
    tabs: ['login', 'email', 'phone'],
    apiMethod: 'GQL',
  },
  typeOfTransactions: 2,
  paymentText: '',
  authBySession: true,
  cashback: {
    variablesContent: {
      type: 'fast_cashback',
      title: 'OlimpCom Casino',
    },
  },
  rules: () => {
    const config = {
      fallback: {
        SUPPORT_EMAIL_RAW: 'support@olimp-casino.com',
        DOMAIN: 'olimp.com',
        DOMAIN_UP: 'Olimp.com',
        TITLE: 'Olimp Casino',
      },
    }

    const result = config[normalizeHost(window.location.hostname)] || config.fallback
    result.SUPPORT_EMAIL = `<a href="mailto:${result.SUPPORT_EMAIL_RAW}">${result.SUPPORT_EMAIL_RAW}</a>`
    result.DOMAIN_LINK = `<a href="https://${result.DOMAIN}" ref='noopener nofollow'>${result.DOMAIN}</a>`

    return result
  },
  license: {
    'olimp.com': {
      key: 'b3ed0d4d-e8c9-4e55-b744-8e3384bfaefa',
      html: `
      <div class="footer-anj__text">
        <a href="/" target="_blank">olimp.com</a> is owned and operated by 3-102-935655 SRL, registration number 3-102-935655, with its registered address at Bufete Sanchez Chavarria, Costado Este de la Municipalidad de Garabito, Av. Pastor Diaz, Puntarenas, Jaco, 61101, Costa Rica. For customer support, please contact helpdesk@olimp.com. olimp.com is licensed and regulated by the Offshore Finance Authority of the Autonomous Island of Anjouan, Union of Comoros, and operates under Internet Gaming License No. ALSI-202509028-FI1. The Operator is legally authorized to conduct online gaming operations for games of chance and wagering in accordance with the terms of its licence.
        <br />
        <br />
        <a href="/rules" target="_blank">General Terms and Conditions</a>.
        <br />
        In the event the General Terms and Conditions are updated, existing users may choose to discontinue using the
        products and services before the said update shall become effective, which is a minimum of two weeks after it
        has been announced.
      </div>`,
    },
  },
  groupRootPath: 'group',
  seo: {
    hostName: [
      {
        domain: 'olimp.com/casino',
        langMap: {
          'x-default': 'x-default',
        },
      },
      {
        domain: 'olimp.com/casino',
        langMap: {
          'ru-KG': 'ru-KG',
        },
      },
      {
        domain: '32olimp.com/casino',
        langMap: {
          'ru-RU': 'ru-RU',
        },
      },
      {
        domain: 'olimp.com/casino',
        langMap: {
          'ru-UZ': 'ru-UZ',
        },
      },
      {
        domain: '32olimp.com/casino',
        langMap: {
          'ru-KZ': 'ru-KZ',
        },
      },
      {
        domain: '32olimp.com/casino/kk',
        langMap: {
          'kk-KZ': 'kk-KZ',
        },
      },
      {
        domain: '32olimp.com/casino/en',
        langMap: {
          'en-KZ': 'en-KZ',
        },
      },
      {
        domain: '32olimp.com/casino/uz',
        langMap: {
          'uz-UZ': 'uz-UZ',
        },
      },
      {
        domain: '32olimp.com/casino/ky',
        langMap: {
          'ky-KG': 'ky-KG',
        },
      },
      {
        domain: '32olimp.com/casino/en',
        langMap: {
          en: 'en',
        },
      },
    ],
  },
  games: {
    iframe: new Set([
      'bg',
      'spribe',
      'jetgames',
      'betsolutions',
      'hollywoodtv',
      'goldenrace',
      'turbogames',
      'sgtv',
      'avx',
      'liw',
    ]),
  },
  regPlatform: getRegPlatform(),
  socialLinks: {
    default: {
      FACEBOOK: 'https://www.facebook.com/olimpcom',
      TG_BOTS: `@olimpcom_bot|${getTelegramLink('olimpcom_bot')}||@olimp_casino|${getTelegramLink('olimp_casino')}`,
      INSTAGRAM: 'https://www.instagram.com/olimp.com.official',
    },
  },
  mainSliders: [
    {
      type: 'games_slider_sub_group',
      groupProp: 'slot',
      subgroupCode: 'hot',
      titleProp: 'hotGames',
      subgroupIcon: 'hot',
      maxRow: 2,
    },
    { type: 'providers_slider' },
    {
      type: 'games_slider_sub_group',
      groupProp: 'exclusive',
      subgroupCode: '',
      titleProp: 'Exclusive',
      allLink: { name: 'GamesByGroup', params: { group: 'exclusive' } },
      maxRow: 1,
    },
    {
      type: 'games_slider_sub_group',
      groupProp: 'recommended',
      subgroupCode: '',
      titleProp: 'recommended',
      titleIcon: 'assets/icon/svg/recommended.svg',
      trackingBlockId: 'recommended',
      allLink: { name: 'GamesByGroup', params: { group: 'recommended' } },
      maxRow: 1,
    },
    { type: 'event_slider' },
    {
      type: 'games_slider_sub_group',
      groupProp: 'online',
      subgroupCode: 'hot',
      titleProp: 'live_casino',
      allLink: { name: 'GamesByGroup', params: { group: 'online' } },
      maxRow: 2,
    },
    { type: 'top_wins_section' },
    {
      type: 'games_slider_sub_group',
      groupProp: 'fast',
      subgroupCode: 'hot',
      titleProp: 'instant',
      allLink: { name: 'GamesByGroup', params: { group: 'fast' } },
      maxRow: 2,
    },
    { type: 'jackpot_section' },
    {
      type: 'games_slider_sub_group',
      groupProp: 'slot',
      subgroupCode: 'cashback',
      titleProp: 'Cashback',
      subgroupIcon: 'cashback',
      maxRow: 2,
    },
    {
      type: 'games_slider_sub_group',
      groupProp: 'slot',
      subgroupCode: 'buybonus',
      titleProp: 'Bonus Buy',
      subgroupIcon: 'buybonus',
      maxRow: 2,
    },
    {
      type: 'games_slider_sub_group',
      groupProp: 'slot',
      subgroupCode: 'drops_and_wins',
      titleProp: 'Drops & Wins',
      subgroupIcon: 'drops_and_wins',
      maxRow: 2,
    },
    { type: 'promotions_slider' },
    {
      type: 'games_slider_sub_group',
      groupProp: 'lottery',
      subgroupCode: 'hot',
      titleProp: 'lottery',
      allLink: { name: 'GamesByGroup', params: { group: 'lottery' } },
      maxRow: 2,
    },
    {
      type: 'games_slider_sub_group',
      groupProp: 'new',
      titleProp: 'new',
      allLink: { name: 'GamesByGroup', params: { group: 'new' } },
      maxRow: 2,
    },
  ],
  pollingType: 'ws',
  loader: {
    color: 'cas-button',
    bgColor: 'rgba(0, 0, 0, 0.6)',
  },
}

function getRegPlatform() {
  if (process.env.OWN_SPORT) {
    return 'CASWOBALANCE'
  }

  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent)
  return isMobile ? 'MCASINO_NEWREG' : 'CASINO_NEWREG'
}
